import { IMAGES } from "@/data/content";
import { Reveal } from "./Reveal";

export const Credentials = () => (
  <section className="credentials" data-testid="credentials-band">
    <Reveal y={32} className="cred cred-mfg" data-testid="credential-manufacturer">
      <img src={IMAGES.apeLogo} alt="APE logo" className="cred-logo" />
      <div>
        <p className="mono-label accent">The Manufacturer</p>
        <h3>OEM-grade pins &amp; bushes — made fully in-house.</h3>
      </div>
    </Reveal>
    <Reveal y={32} delay={0.12} className="cred cred-jic" data-testid="credential-distributor">
      <img src={IMAGES.jicLogo} alt="JIC Hydraulics" className="cred-logo cred-logo-jic" />
      <div>
        <p className="mono-label lime">The Master Distributor</p>
        <h3>Authorised Master Distributor of JIC Hydraulics — India.</h3>
      </div>
    </Reveal>
  </section>
);
